export default __webpack_public_path__ + "static/m-hnh3-af1ff3628e03054173010737047bdc20.jpg";